import { type OrganizationSummary } from "@api/rest/types-and-hooks";
import { ScopedQARules } from "@pages/QARules/ScopedQARules";
import { QARulesScope } from "@pages/QARules/constants";

interface TemplateQARulesTabProps {
  templateId: number;
  /** Orgs the template is assigned to — the only orgs its preview can be viewed for. */
  organizations: readonly OrganizationSummary[];
}

export const TemplateQARulesTab: React.FC<TemplateQARulesTabProps> = ({ templateId, organizations }) => (
  <ScopedQARules scope={QARulesScope.TEMPLATE} scopeId={templateId} organizationChoices={organizations} />
);
